module.exports = __webpack_public_path__ + "images/emoji/oncoming_police_car.592253bdb13c726ed749.png";